import React, { useEffect } from "react";
import HomeMain from "./HomeMain";
import HomeAbout from "./HomeAbout";
import HomeImageSlider from "./HomeImageSlider";
import HomeFeatures from "./HomeFeatures";
import HomeLocation from "./HomeLocation";
import HomeReviews from "./HomeReviews";
import HomeExplore from "./HomeExplore";
import HomeGallery from "./HomeGallery";

const Home = () => {
  useEffect(() => {
    document.title = "Cabin Woods";
  }, []);

  return (
    <>
      <HomeMain />
      <div className="section">
        <HomeAbout />
        <HomeImageSlider />
        <HomeFeatures />
        <HomeLocation />
        <HomeReviews />
        <HomeExplore />
        <HomeGallery />
      </div>
    </>
  );
};

export default Home;
